import React from 'react';
import {
    MainContainerItems,
    DisplayCard,
    ContainerItems,
    Value,
} from 'src/pages/orders/components/orderDetails/backOrderDetails/BackOrderDetails.styled';
import {
    DetailsMainContainerBlock,
    Header,
    ItemContainer,
} from 'src/pages/orders/components/orderDetails/replenRequest/ReplenRequest.styled';
import CfnLabel from 'src/common/components/orderDetails/bundleCards/CfnLabel';
import ItemDescriptionLabel from 'src/common/components/orderDetails/bundleCards/ItemDescriptionLabel';
import { useTranslation } from 'react-i18next';
  
const BackOrderCards = ({ data, setItemHandler, isEquity, textAlign }) => {
    const { t } = useTranslation();
    return (
        <DisplayCard key={data.cfn}>
            <DetailsMainContainerBlock>
                <MainContainerItems
                    marginBottom={'10px'}
                    mbPadding={'0.4rem 0 0 0'}
                >
                    {data?.cfn ? (
                        <CfnLabel
                            setItemHandler={setItemHandler}
                            setDetailsData={data}
                            cfn={data.cfn}
                            isShowSetItemDetails={true}
                            cursor={'pointer'}
                            isEquity={isEquity}
                            textAlign={textAlign}
                        />
                    ) : null}
                    <ItemDescriptionLabel
                        lineHeight={'19px'}
                        letterSpacing={'-0.1px'}
                        description={data.description}
                        fontSize={'13px'}
                    />
                </MainContainerItems>
                <ContainerItems marginBottom={'6px'}>
                    <ItemContainer>
                        <Header color={'#202124'}>{t('orders.orderDetails.replenRequest.ordered')}</Header>
                        <Value> {data?.orderedQty ? data.orderedQty : 0}</Value>
                    </ItemContainer>
                    <ItemContainer>
                        <Header color={'#202124'}>{t('orders.orderDetails.replenRequest.shipped')}</Header>
                        <Value> {data?.shippedQty ? data.shippedQty : 0}</Value>
                    </ItemContainer>
                    <ItemContainer>
                        <Header
                            color={
                                data.backOrderQty > 0 ? '#ED002A' : '#202124'
                            }
                        >
                            {t('orders.orderDetails.replenRequest.backOrder')}
                        </Header>
                        <Value
                            color={
                                data.backOrderQty > 0 ? '#ED002A' : '#000000'
                            }
                        >
                            {data?.backOrderQty ? data.backOrderQty : 0}
                        </Value>
                    </ItemContainer>
                </ContainerItems>
            </DetailsMainContainerBlock>
        </DisplayCard>
    );
};

export default BackOrderCards;
